/**
 * @fileoverview アナシスのダウンロードとインストール方法
 */
import { Step } from "../components/Step";
import { useTranslation } from "react-i18next";
import DL01Ja from "./img/anasysDownloadButtonJ.png";
import DL02Ja from "./img/downloadSetupJ.png";
import DL03Ja from "./img/extractSetupJ1.png";
import DL04Ja from "./img/extractSetupJ2.png";
import DL05Ja from "./img/extractSetupJ3.png";
import install1Ja from "./img/anasysInstallJ1.png";
import install2Ja from "./img/anasysInstallJ2.png";
import install3Ja from "./img/anasysInstallJ3.png";
import install4Ja from "./img/anasysInstallJ4.png";
import install5Ja from "./img/anasysInstallJ5.png";
import install6Ja from "./img/launchAnasysJ.png";
import DL01En from "./img/English/AnasysDownloadButton.png";
import DL02En from "./img/English/downloadSetup.png";
import DL03En from "./img/English/ExtractAllSetup.png";
import DL04En from "./img/English/extractSetup.png";
import DL05En from "./img/English/extractEndSetup.png";
import install1En from "./img/English/AnasysInstall1.png";
import install2En from "./img/English/AnasysInstall2.png";
import install3En from "./img/English/AnasysInstall3.png";
import install4En from "./img/English/AnasysInstall4.png";
import install5En from "./img/English/AnasysInstall5.png";
import install6En from "./img/English/LaunchAnasys.png";
import DL01Ko from "./img/Korean/anasysDownloadPageK.png";
import DL02Ko from "./img/Korean/dlSetupK02.png";
import DL03Ko from "./img/Korean/dlSetupK03.png";
import DL04Ko from "./img/Korean/dlSetupK04.png";
import DL05Ko from "./img/Korean/dlSetupK05.png";
/**
 * アナシスのダウンロードとインストール方法ページのコンポーネント
 * @returns {JSX.Element} アナシスのダウンロードとインストール方法ページの JSX element
 */
export function HowToDownloadAndInstall(): JSX.Element {
  const { t, i18n } = useTranslation();

  //画像のリスト
  const images = {
    ja: {
      DL01: DL01Ja,
      DL02: DL02Ja,
      DL03: DL03Ja,
      DL04: DL04Ja,
      DL05: DL05Ja,
      install1: install1Ja,
      install2: install2Ja,
      install3: install3Ja,
      install4: install4Ja,
      install5: install5Ja,
      install6: install6Ja,
    },
    en: {
      DL01: DL01En,
      DL02: DL02En,
      DL03: DL03En,
      DL04: DL04En,
      DL05: DL05En,
      install1: install1En,
      install2: install2En,
      install3: install3En,
      install4: install4En,
      install5: install5En,
      install6: install6En,
    },
    ko: {
      DL01: DL01Ko,
      DL02: DL02Ko,
      DL03: DL03Ko,
      DL04: DL04Ko,
      DL05: DL05Ko,
      install1: install1En,
      install2: install2En,
      install3: install3En,
      install4: install4En,
      install5: install5En,
      install6: install6En,
    },
  };

  //現在の言語に基づいて画像決定
  const currentImages =
    i18n.language === "ja"
      ? images.ja
      : i18n.language === "ko"
      ? images.ko
      : images.en;

  /**
   * ダウンロード手順
   */
  const steps_download = [
    {
      step: "1.",
      text: (
        <>
          {t(
            "[アナシス ダウンロード]をクリックすると、ダウンロードを開始します。"
          )}
        </>
      ),
      image: currentImages.DL01,
      alt: t("名前を付けて保存"),
      point_text: (
        <p className="u-font-red">
          <b>
            {t(
              "必ず一度ファイルを保存してからインストールを実行してください。"
            )}
            {t(
              "ダウンロード時に[開く]ボタンを押すと正しくインストールが行われない場合があります。"
            )}
          </b>
        </p>
      ),
    },

    {
      step: "2.",
      text: (
        <>
          {t("ダウンロードが完了すると以下の画面が表示されます。")}
          {t("[フォルダーに表示]ボタンをクリックしてください。")}
        </>
      ),
      image: currentImages.DL02,
      alt: t("ダウンロード完了"),
    },

    {
      step: "3.",
      text: t(
        "ダウンロードしたsetup.zipを右クリックし，[すべて展開]をクリックします。"
      ),
      image: currentImages.DL03,
      alt: t("すべて展開"),
    },

    {
      step: "4.",
      text: t("インストーラーを置きたい場所を選んで[展開]をクリックします。"),
      image: currentImages.DL04,
      alt: t("setupフォルダ"),
    },

    {
      step: "5.",
      text: t(
        "展開が完了したら，作成されたsetupフォルダー内のsetup.exeをダブルクリックします。"
      ),
      image: currentImages.DL05,
      alt: t("展開完了"),
    },
  ];

  /**
   * インストールの手順
   */
  const steps_install = [
    {
      step: "1.",
      text: (
        <>
          {t("インストールのウィザードが表示されます。")}
          {t("[次へ]ボタンをクリックします。")}
        </>
      ),
      image: currentImages.install1,
      alt: t("ようこそ"),
      point_text: (
        <>
          {t(
            "[Error reading setup initialization file]といったエラーが表示された場合には，インストールに必要なファイルの全容量をダウンロードできていません。"
          )}
          {t("この場合には再度ダウンロード操作を行ってください。")}
        </>
      ),
    },

    {
      step: "2.",
      text: (
        <>
          {t(
            "アナシスの利用規約とプライバシーポリシーの確認画面が表示されます。"
          )}
          {t(
            "ご同意いただける場合は[同意する]を選択して，[次へ]ボタンをクリックします。"
          )}
        </>
      ),
      image: currentImages.install2,
      alt: t("利用規約"),
    },

    {
      step: "3.",
      text: (
        <>
          {t("インストールフォルダーの選択画面を表示します。")}
          {t(
            "インストール場所を変更する場合は，フォルダー欄にアドレスを入力するか，「参照」ボタンをクリックします。"
          )}
          {t(
            "1台のパソコンを複数のユーザーで共有して使用する環境で複数ユーザー全てがアナシスを使用する場合は[すべてのユーザー]を選択してください。"
          )}
          {t(
            "現在のユーザーだけで使用する場合には[このユーザーのみ]を選択してください。"
          )}
          {t("[次へ]ボタンをクリックします。")}
        </>
      ),
      image: currentImages.install3,
      alt: t("インストールフォルダー選択"),
    },

    {
      step: "4.",
      text: (
        <>
          {t("インストールの確認画面を表示します。")}
          {t("[次へ]ボタンをクリックします。")}
        </>
      ),
      image: currentImages.install4,
      alt: t("インストール開始"),
      point_text: t(
        "インストール開始前に、ユーザーアカウント制御画面が表示されたら、[はい]をクリックします。"
      ),
    },

    {
      step: "5.",
      text: t(
        "インストールが完了します。[閉じる]ボタンをクリックしインストールを終了します。"
      ),
      image: currentImages.install5,
      alt: t("完了"),
    },

    {
      step: "6.",
      text: (
        <>
          {t(
            "アナシスを起動します。[スタート]-[すべてのプログラム]-[アナシス6]を選択してください。"
          )}
          {t("以下の画面となりアナシスが起動したことを確認します。")}
          <br />
        </>
      ),
      image: currentImages.install6,
      alt: t("アナシス起動"),
    },
  ];

  return (
    <>
      <h2 className="p-heading-2">{t("ダウンロードとインストールの手順")}</h2>
      <p className="c-text">
        {t(
          "アナシスのダウンロードからインストールまでの一連の操作手順をお知らせします。"
        )}
      </p>
      <h3 className="p-heading-3">{t("ダウンロード手順")}</h3>
      {steps_download.map((step, index) => (
        <Step
          key={index}
          step={step.step}
          text={step.text}
          image={step.image}
          point_text={step.point_text}
        />
      ))}
      <h3 className="p-heading-3">{t("インストールの手順")}</h3>
      {steps_install.map((step, index) => (
        <Step
          key={index + steps_download.length}
          step={step.step}
          text={step.text}
          image={step.image}
          point_text={step.point_text}
        />
      ))}
    </>
  );
}
